import React from "react";
import styled from "styled-components";

const ServicesSection = ({ data = {} }) => {
  const { eyebrow = "Services we provide", title = "", services = [] } = data;

  return (
    <Section>
      <Header>
        <Eyebrow>{eyebrow}</Eyebrow>
        <Title>{title}</Title>
      </Header>

      <ServicesGrid>
        {services.map((service, i) => (
          <ServiceCard key={i}>
            <CardImage>
              <img src={service.image} alt={service.title} />
            </CardImage>
            <CardContent>
              <ServiceTitle>{service.title}</ServiceTitle>
              {service.description && <ServiceDescription>{service.description}</ServiceDescription>}
              {service.description2 && <ServiceDescription>{service.description2}</ServiceDescription>}
              {service.bullets && service.bullets.length > 0 && (
                <BulletList>
                  {service.bullets.map((bullet, index) => (
                    <BulletItem key={index}>
                      <BulletIcon>✓</BulletIcon>
                      <span>{bullet}</span>
                    </BulletItem>
                  ))}
                </BulletList>
              )}
            </CardContent>
          </ServiceCard>
        ))}
      </ServicesGrid>
    </Section>
  );
};

export default ServicesSection;

const Section = styled.section`
  padding: 80px 80px;
  background: #FFF;
  color: #000;
  @media (max-width: 768px) { padding: 60px 24px; }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 64px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const Eyebrow = styled.span`
  display: block;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #1F514C;
  margin-bottom: 16px;
  opacity: 0.8;
`;

const Title = styled.h2`
  font-size: 42px;
  color: #2b2b2b;
  font-family: 'Playfair Display', serif;
  font-weight: 500;
  line-height: 1.2;
  margin-bottom: 0;
  @media (max-width: 768px) { font-size: 32px; }
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  @media (max-width: 1024px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 768px) { grid-template-columns: 1fr; gap: 24px; }
`;

const ServiceCard = styled.div`
  background: #F6F6F6;
  border-radius: 25px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  &:hover { transform: translateY(-8px); box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1); }
`;

const CardImage = styled.div`
  width: 100%;
  height: 200px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
    ${ServiceCard}:hover & { transform: scale(1.05); }
  }
`;

const CardContent = styled.div`
  padding: 32px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

const ServiceTitle = styled.h3`
  font-size: 24px;
  color: #000;
  font-family: 'Playfair Display', serif;
  font-weight: 500;
  margin-bottom: 16px;
  line-height: 1.3;
`;

const ServiceDescription = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: #333;
  margin-bottom: 16px;
  opacity: 0.9;
  flex-grow: 0;
`;

const BulletList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: 8px;
`;

const BulletItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 20px;
  color: #333;
  &:last-child { margin-bottom: 0; }
`;

const BulletIcon = styled.span`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  background: #000;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  margin-top: 2px;
`;
